import React from "react";
import { Switch, Route } from "react-router-dom";
import { combineReducers } from "redux";

// Components
import Translate from "./Translate";

// Reducers
import translateReducer from "./Translate/store/translateReducer";

// Routes
export const routes = (basePath, permissions) => <Switch>{<Route path={basePath} exact component={Translate} />}</Switch>;

export const reducers = combineReducers({
    translations: translateReducer
});
